import React from 'react';
import { ModuleBridge, TopActionBar, ReportDateRangePicker } from '../components';

export const ReportingMigrationsAWSTargetInstance = () => {
    return (
        <>
            <TopActionBar>
                <ReportDateRangePicker />
            </TopActionBar>
            <div id="backbone_reporting_migrations_aws_target_instance_wrapper"></div>
            <ModuleBridge moduleId="reporting_migrations_aws_target_instance" />
        </>
    );
};
